import axios from 'axios';

export const requestResetPassword = async values =>
  axios.post(`/users/reset-password/${values.emailAddress}`, { ...values });

export const verifyResetPassword = async values =>
  axios.post(`/users/reset-password/verify/${values.token}`, { ...values });

export default { requestResetPassword, verifyResetPassword };
